// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Feedback Popup Styles */
:root {
  --feedback-primary-blue: #1b2c5a;
  --feedback-primary-gold: #d5a32a;
  --feedback-white: #ffffff;
  --feedback-light-gray: #f8f9fa;
  --feedback-dark-gray: #6c757d;
  --feedback-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  --feedback-shadow-heavy: 0 20px 40px rgba(0, 0, 0, 0.25);
  --feedback-border-radius: 12px;
  --feedback-transition: 0.3s ease-out;
}

/* Overlay */
.feedback-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  opacity: 1;
  transition: opacity var(--feedback-transition);
}

.feedback-popup-overlay.closing {
  opacity: 0;
}

/* Popup Container */
.feedback-popup {
  background: var(--feedback-white);
  border-radius: var(--feedback-border-radius);
  box-shadow: var(--feedback-shadow-heavy);
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  position: relative;
  transform: scale(1);
  opacity: 1;
  transition: all var(--feedback-transition);
  animation: feedback-slide-in 0.4s ease-out;
}

.feedback-popup.closing {
  transform: scale(0.9);
  opacity: 0;
}

@keyframes feedback-slide-in {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Close Button */
.feedback-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 0.75rem 1.5rem;
  background: #d5a32a;
  color: #ffffff;
  border-radius: 0.75rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: 'Roboto', sans-serif;
}

.feedback-close-button:hover {
  background: #f2c94c;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.feedback-close-button:active {
  transform: translateY(0);
}

/* Content */
.feedback-content {
  text-align: center;
  padding-top: 1rem;
}

/* Icon */
.feedback-icon {
  margin-bottom: 1.5rem;
  color: var(--feedback-primary-blue);
  display: flex;
  justify-content: center;
}

.feedback-icon svg {
  filter: drop-shadow(0 2px 4px rgba(27, 44, 90, 0.1));
}

/* Title */
.feedback-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--feedback-primary-blue);
  margin: 0 0 1rem 0;
  line-height: 1.3;
}

/* Message */
.feedback-message {
  color: var(--feedback-dark-gray);
  line-height: 1.6;
  margin: 0 0 2rem 0;
  font-size: 1rem;
}

/* Actions */
.feedback-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

/* Primary Button */
.feedback-primary-button {
  background: linear-gradient(135deg, var(--feedback-primary-blue), #2a3f7a);
  color: var(--feedback-white);
  border: none;
  padding: 1rem 1.5rem;
  border-radius: var(--feedback-border-radius);
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all var(--feedback-transition);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.2);
}

.feedback-primary-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(27, 44, 90, 0.3);
}

.feedback-primary-button:active {
  transform: translateY(0);
}

/* Hat Icon */
.feedback-hat-icon {
  transition: transform var(--feedback-transition);
}

.feedback-primary-button:hover .feedback-hat-icon {
  transform: rotate(15deg) scale(1.1);
}

/* Secondary Button */
.feedback-secondary-button {
  background: var(--feedback-light-gray);
  color: var(--feedback-dark-gray);
  border: 1px solid #e9ecef;
  padding: 0.75rem 1.5rem;
  border-radius: var(--feedback-border-radius);
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all var(--feedback-transition);
}

.feedback-secondary-button:hover {
  background: #e9ecef;
  color: var(--feedback-primary-blue);
  transform: translateY(-1px);
}

/* Responsive Design */
@media (max-width: 480px) {
  .feedback-popup {
    padding: 1.5rem;
    margin: 1rem;
  }
  
  .feedback-title {
    font-size: 1.25rem;
  }
  
  .feedback-message {
    font-size: 0.9rem;
  }
  
  .feedback-primary-button {
    padding: 0.875rem 1.25rem;
    font-size: 0.9rem;
  }
  
  .feedback-secondary-button {
    padding: 0.625rem 1.25rem;
    font-size: 0.85rem;
  }
}

@media (max-width: 360px) {
  .feedback-popup {
    padding: 1.25rem;
    margin: 0.5rem;
  }
  
  .feedback-title {
    font-size: 1.125rem;
  }
  
  .feedback-message {
    font-size: 0.85rem;
  }
  
  .feedback-actions {
    gap: 0.5rem;
  }
}

/* High Contrast Mode Support */
@media (prefers-contrast: high) {
  .feedback-popup {
    border: 2px solid var(--feedback-primary-blue);
  }
  
  .feedback-primary-button {
    border: 2px solid var(--feedback-primary-blue);
  }
  
  .feedback-secondary-button {
    border: 2px solid var(--feedback-dark-gray);
  }
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
  .feedback-popup,
  .feedback-popup-overlay,
  .feedback-close-button,
  .feedback-primary-button,
  .feedback-secondary-button,
  .feedback-hat-icon {
    transition: none;
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FeedbackPopup.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,gCAAgC;EAChC,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;EAC7B,kDAAkD;EAClD,wDAAwD;EACxD,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;EACjC,4CAA4C;EAC5C,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,mCAAmC;EACnC,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oDAAoD;AACtD;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,0EAA0E;EAC1E,4BAA4B;EAC5B,YAAY;EACZ,oBAAoB;EACpB,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,gDAAgD;AAClD;;AAEA;EACE,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,sCAAsC;EACtC,gCAAgC;EAChC,yBAAyB;EACzB,uBAAuB;EACvB,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,8CAA8C;EAChD;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,2CAA2C;EAC7C;AACF;;AAEA,2BAA2B;AAC3B;EACE;;;;;;IAME,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["/* Feedback Popup Styles */\n:root {\n  --feedback-primary-blue: #1b2c5a;\n  --feedback-primary-gold: #d5a32a;\n  --feedback-white: #ffffff;\n  --feedback-light-gray: #f8f9fa;\n  --feedback-dark-gray: #6c757d;\n  --feedback-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  --feedback-shadow-heavy: 0 20px 40px rgba(0, 0, 0, 0.25);\n  --feedback-border-radius: 12px;\n  --feedback-transition: 0.3s ease-out;\n}\n\n/* Overlay */\n.feedback-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  opacity: 1;\n  transition: opacity var(--feedback-transition);\n}\n\n.feedback-popup-overlay.closing {\n  opacity: 0;\n}\n\n/* Popup Container */\n.feedback-popup {\n  background: var(--feedback-white);\n  border-radius: var(--feedback-border-radius);\n  box-shadow: var(--feedback-shadow-heavy);\n  padding: 2rem;\n  max-width: 400px;\n  width: 90%;\n  position: relative;\n  transform: scale(1);\n  opacity: 1;\n  transition: all var(--feedback-transition);\n  animation: feedback-slide-in 0.4s ease-out;\n}\n\n.feedback-popup.closing {\n  transform: scale(0.9);\n  opacity: 0;\n}\n\n@keyframes feedback-slide-in {\n  from {\n    opacity: 0;\n    transform: scale(0.8) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n/* Close Button */\n.feedback-close-button {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  padding: 0.75rem 1.5rem;\n  background: #d5a32a;\n  color: #ffffff;\n  border-radius: 0.75rem;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.875rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  font-family: 'Roboto', sans-serif;\n}\n\n.feedback-close-button:hover {\n  background: #f2c94c;\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);\n  transform: translateY(-1px);\n}\n\n.feedback-close-button:active {\n  transform: translateY(0);\n}\n\n/* Content */\n.feedback-content {\n  text-align: center;\n  padding-top: 1rem;\n}\n\n/* Icon */\n.feedback-icon {\n  margin-bottom: 1.5rem;\n  color: var(--feedback-primary-blue);\n  display: flex;\n  justify-content: center;\n}\n\n.feedback-icon svg {\n  filter: drop-shadow(0 2px 4px rgba(27, 44, 90, 0.1));\n}\n\n/* Title */\n.feedback-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--feedback-primary-blue);\n  margin: 0 0 1rem 0;\n  line-height: 1.3;\n}\n\n/* Message */\n.feedback-message {\n  color: var(--feedback-dark-gray);\n  line-height: 1.6;\n  margin: 0 0 2rem 0;\n  font-size: 1rem;\n}\n\n/* Actions */\n.feedback-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n/* Primary Button */\n.feedback-primary-button {\n  background: linear-gradient(135deg, var(--feedback-primary-blue), #2a3f7a);\n  color: var(--feedback-white);\n  border: none;\n  padding: 1rem 1.5rem;\n  border-radius: var(--feedback-border-radius);\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all var(--feedback-transition);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.2);\n}\n\n.feedback-primary-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(27, 44, 90, 0.3);\n}\n\n.feedback-primary-button:active {\n  transform: translateY(0);\n}\n\n/* Hat Icon */\n.feedback-hat-icon {\n  transition: transform var(--feedback-transition);\n}\n\n.feedback-primary-button:hover .feedback-hat-icon {\n  transform: rotate(15deg) scale(1.1);\n}\n\n/* Secondary Button */\n.feedback-secondary-button {\n  background: var(--feedback-light-gray);\n  color: var(--feedback-dark-gray);\n  border: 1px solid #e9ecef;\n  padding: 0.75rem 1.5rem;\n  border-radius: var(--feedback-border-radius);\n  font-weight: 500;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all var(--feedback-transition);\n}\n\n.feedback-secondary-button:hover {\n  background: #e9ecef;\n  color: var(--feedback-primary-blue);\n  transform: translateY(-1px);\n}\n\n/* Responsive Design */\n@media (max-width: 480px) {\n  .feedback-popup {\n    padding: 1.5rem;\n    margin: 1rem;\n  }\n  \n  .feedback-title {\n    font-size: 1.25rem;\n  }\n  \n  .feedback-message {\n    font-size: 0.9rem;\n  }\n  \n  .feedback-primary-button {\n    padding: 0.875rem 1.25rem;\n    font-size: 0.9rem;\n  }\n  \n  .feedback-secondary-button {\n    padding: 0.625rem 1.25rem;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 360px) {\n  .feedback-popup {\n    padding: 1.25rem;\n    margin: 0.5rem;\n  }\n  \n  .feedback-title {\n    font-size: 1.125rem;\n  }\n  \n  .feedback-message {\n    font-size: 0.85rem;\n  }\n  \n  .feedback-actions {\n    gap: 0.5rem;\n  }\n}\n\n/* High Contrast Mode Support */\n@media (prefers-contrast: high) {\n  .feedback-popup {\n    border: 2px solid var(--feedback-primary-blue);\n  }\n  \n  .feedback-primary-button {\n    border: 2px solid var(--feedback-primary-blue);\n  }\n  \n  .feedback-secondary-button {\n    border: 2px solid var(--feedback-dark-gray);\n  }\n}\n\n/* Reduced Motion Support */\n@media (prefers-reduced-motion: reduce) {\n  .feedback-popup,\n  .feedback-popup-overlay,\n  .feedback-close-button,\n  .feedback-primary-button,\n  .feedback-secondary-button,\n  .feedback-hat-icon {\n    transition: none;\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
